
/**
 * PALTFORM MODULES
 */
import Emitter        from '@shared/services/main/events';
import RequestClient  from '@shared/services/main/request-client';
import BaseService    from '@shared/services/base/BaseService'
import ENDPOINTS      from '@shared/lib/constants/endpoints';
import EVENT_NAMES    from '@shared/lib/constants/events';

/**
 * Regsiter Service
 *
 * @class      CsrfService (name)
 */
function CsrfService(component) {
  this.component            = component;
  this.event_group          = EVENT_NAMES.PLATFORM.SESSIONS;
  this.hostname             = process.env.REACT_APP_PLATFORM_API_BASE_URL;
  this.read_endpoint        = this.hostname + ENDPOINTS.PLATFORM.SESSIONS_CSRF;
  this.used_interceptor     = false;
  this.session_watch_timout = null;
  this.sec_interval         = 300;
}

CsrfService.prototype = Object.assign(CsrfService.prototype, BaseService.prototype);

/**
 * Triggers the watch timeout
 */
CsrfService.prototype.watchCsrfToken = function() {
  if (this.session_watch_timout) {
    this.stopWatchingCsrfTokem();
  }
  const mili = this.sec_interval * 1000;
  this.session_watch_timout = setInterval(
    this.onCsrfProceed.bind(this),
    mili
  );
  this.onCsrfProceed();
};

/**
 * Stops watching session timeout.
 */
CsrfService.prototype.stopWatchingCsrfTokem = function() {
  clearInterval(this.session_watch_timout);
};

/**
 * Registers Regsiter events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
CsrfService.prototype.registerCsrfEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.CSRF_WATCH]   = 'watchCsrfToken';
  event_callback_map[this.event_group.CSRF_PROCEED] = 'onCsrfProceed';
  event_callback_map[this.event_group.CSRF_SUCCESS] = 'onCsrfSuccess';
  event_callback_map[this.event_group.CSRF_FAIL]    = 'onCsrfFail';
  this.registerEvents(event_callback_map, service);
  Emitter.register(
    EVENT_NAMES.PLATFORM.SESSIONS.TOKEN_SUCCESS_AFTER + '-csrf-service',
    this.watchCsrfToken.bind(this)
  );
  Emitter.register(
    EVENT_NAMES.PLATFORM.SESSIONS.CLOSE_SUCCESS_AFTER + '-csrf-service',
    this.stopWatchingCsrfTokem.bind(this)
  );
  return this;
}

/**
 * Removes Regsiter events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
CsrfService.prototype.removeCsrfEvents = function() {
  this.removeEvents([
    this.event_group.CSRF_WATCH,
    this.event_group.CSRF_PROCEED,
    this.event_group.CSRF_SUCCESS,
    this.event_group.CSRF_FAIL
  ]);
  Emitter.off(EVENT_NAMES.PLATFORM.SESSIONS.TOKEN_SUCCESS_AFTER + '-csrf-service');
  Emitter.off(EVENT_NAMES.PLATFORM.SESSIONS.CLOSE_SUCCESS_AFTER + '-csrf-service');
  return this;
}


/**
 * Called when Regsiter proceed.
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
CsrfService.prototype.onCsrfProceed = function() {
  let token_source = this.renewCancelToken(RequestClient, this.event_group.CSRF_PROCEED);
  let request =  RequestClient.head(this.read_endpoint, {
    cancelToken: token_source.token,
  })
  this.bindResultEvents(
    request,
    this.event_group.CSRF_SUCCESS,
    this.event_group.CSRF_FAIL
  );
  request.finally(() => {
  });
};

/**
 * Called on Regsiter success.
 *
 * @param      {object}  response  The response
 */
CsrfService.prototype.onCsrfSuccess = function() {
  /**
   * ALso emit other extensions
   */
  Emitter.emit(EVENT_NAMES.PLATFORM.SESSIONS.CSRF_SUCCESS_AFTER, {});
}

/**
 * Called on Regsiter fail.
 */
CsrfService.prototype.onCsrfFail = function() {
}

export default CsrfService;